// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2013 Minted LLC
 *
 * All Rights Reserved
 *
 * Javascript for product details page
 */

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

M.View.ProductDetails.DieCutIncompatWarningDialog = Backbone.View.extend({
  template: _.template(M.Template.ProductDetails.DieCutIncompatWarningDialog),

  tagName: 'div',
  events: {
    'click .accept': 'onAccept',
    'click .cancel': 'onCancel'
  },

  initialize: function() {
    M.required(this.options.isThickPaperSelected);
    M.required(this.options.isFoldedFormatSelected);
    M.assert(this.options.isFoldedFormatSelected || this.options.isThickPaperSelected,
      'expected either invalid diecut combination');
    this.$el = $(this.el);
  },

  render: function() {
    this.$el.html(this.template(this.options));
    var warningTitle;
    if (this.options.isThickPaperSelected) {
      warningTitle = "You've selected a special shape and " + this.options.paperName + " Paper.";
    } else if (this.options.isFoldedFormatSelected) {
      warningTitle = "You've selected a special shape and a folded card.";
    } else {
      M.assert(false, 'expected either invalid diecut combination');
    };

    this.$el.dialog({
      title: warningTitle,
      draggable: false,
      modal: false,
      width: 450,
      autoOpen: true
    });

    return this;
  },

  onAccept: function() {
    this.trigger('accept');
    this.$el.dialog('close');
    this.$el.remove();
    this.remove();
  },

  onCancel: function() {
    this.$el.dialog('close');
    this.$el.remove();
    this.remove();
  }
});
